import { Suspense, useEffect, useState } from "react";
import { deleteItem, fetchPaginationData } from "../../../utils/apiUtils";
import DeleteModel from "../../../Components/DeleteModel";
import Spinner from "../../../Components/spinner";
import Breadcrumb from "../../../Components/Breadcrumb";
import Pagination from "../../../Components/Pagination";
import { ActionButton, PlusButton } from "../../../Components/TableHelper";
import { formatDate } from "../../../utils/constant";
import TableSearch from "../../../Components/TableSearch";
import PerPageSelect from "../../../Components/PerPageSelect";
import AddPage from "./AddPage";
import { useDebounce } from "../../../hooks/useDebounce";
const Page = () => {
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [editData, setEditData] = useState({});

  const fetchDataPagination = async (
    page = 1,
    currentSearch = search,
    currentPerPage = perPage,
  ) => {
    const requestData = {
      perPage: currentPerPage,
      pageNo: page,
      search: currentSearch,
    };
    await fetchPaginationData(
      "page/getAllPages",
      requestData,
      setdata,
      setTotalCount,
      setCurrentPage,
      setLoading,
    );
  };
  useEffect(() => {
    fetchDataPagination(1);
  }, []);
const debouncedFetch = useDebounce((searchValue) => {
    fetchDataPagination(1, searchValue);
  }, 500);

  const handleSearchChange = (value) => {
    setSearch(value);
    debouncedFetch(value);
  };
  const handlePerPageChange = (value) => {
    setPerPage(value);
    fetchDataPagination(1, search, value);
  };
  const totalPages = Math.ceil(totalCount / perPage);
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchDataPagination(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };

  const handleEditClick = (item) => {
    setEditData(item);
  };
  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem(
        "page/deletePage",
        deleteItemId?._id,
        fetchPaginationData,
      );
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };

  const breadcrumbdata = [
    { label: "Home", path: "/" },
    { label: "Page", path: "*" },
  ];

  const Tableheader = ["Page Name", "Page Action", "Action"];
  return (
    <div className="content-wrapper">
      <div className="page-header d-flex justify-content-between">
        <h3 className="custom-page-title">Page</h3>
        <Breadcrumb items={breadcrumbdata} />
      </div>

      <div
        className="d-flex justify-content-between mb-2 bg-white p-2"
        style={{ marginTop: "-20px" }}
      >
        <PerPageSelect value={perPage} onChange={handlePerPageChange} />
        <div style={{ display: "flex", gap: "10px" }}>
          <TableSearch value={search}  onChange={handleSearchChange} />
          <PlusButton module={"Add"} />
        </div>
      </div>
      <div>
        <AddPage
          fetchPaginationData={fetchDataPagination}
         editData={editData}
        setEditData={setEditData}
        />
      </div>
      <div className="row" style={{ marginTop: "10px" }}>
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive ">
                <table
                  className=" custom-table table table-striped"
                  id="pagewiseBannerTable"
                >
                  <thead>
                    <tr>
                      {Tableheader &&
                        Tableheader.length > 0 &&
                        Tableheader.map((item, index) => (
                          <th className="font-weight-bold" key={index}>
                            {item}
                          </th>
                        ))}
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="12" className="text-center">
                          <Spinner />
                        </td>
                      </tr>
                    ) : data.length > 0 ? (
                      data.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td>{item?.pageName}</td>
                            <td>
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "6px",
                                }}
                              >
                                {item?.action?.map((act, i) => {
                                  const actionClass = act
                                    .toLowerCase()
                                    .replace(" ", "-");
                                  return (
                                    <span
                                       key={`${item._id}-${act}-${i}`}
                                      className={`custom-status-badge badge-${actionClass}`}
                                    >
                                      {act}
                                    </span>
                                  );
                                })}
                              </div>
                            </td>
                            <td>{formatDate(item.updatedAt)}</td>
                            <td>
                              <ActionButton
                                data={item}
                                handleEditClick={handleEditClick}
                                handleDelete={handleDelete}
                                module={"Page"}
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          <h5>No data found.</h5>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {data.length > 0 && (
                <div>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageClick}
                    perPage={perPage}
                    totalCount={totalCount}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {deleteModalOpen && (
          <Suspense fallback={null}>
            <DeleteModel
              deleteModalOpen={deleteModalOpen}
              setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
              onConfirm={confirmDelete}
              itemName="Page permission"
              isDeleting={isDeleting}
            />
          </Suspense>
        )}
      </div>
    </div>
  );
};

export default Page;
